// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base, Block, BlockContent, BlockHeading } from '@gandi/ui';

import { DCVMethodOption } from './DCVMethodOption';

type StepValidationProps = {
  // force automatic dcv (shs)
  forceAutoDCV?: boolean,
};
export function StepValidation({
  forceAutoDCV,
}: StepValidationProps): React.MixedElement {
  const { __ } = useTranslator();

  if (forceAutoDCV) {
    return (
      <Block>
        <BlockHeading>{__('Validation method')}</BlockHeading>
        <BlockContent>
          <Base tagName="p" margin="none">
            {__(
              'Since your certificate will be used with a domain name registered at Gandi, its validation will be done automatically.',
            )}
          </Base>
        </BlockContent>
      </Block>
    );
  }

  return <DCVMethodOption />;
}
